import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { defineComponent, ref } from "vue";
import { flowStatusArr } from "./flow-status-tabs.constant";
import { getCount } from "./flow-status-tabs.service";
import { VoidBtnModuleArr,changeBtnModuleArr } from '../table-flow-btn/flow-btn.constant';
import _ from 'lodash';
export default defineComponent({
  isGlobal: true,
  name: "FlowStatusTab",
  components: {},
  props: {
    bizCode: {
      type: String,
      default: '',
      require: true,
    },
    flowStatus: {
      type: String,
      default: 'sptg',
    },
  },
  emits: ["update:flowStatus", "change", "getStatusList"],
  setup(props, { emit }) {
    const changeTab = (key) => {
      emit("update:flowStatus", key);
    };
    const flowCountMap = new Map();
    const arr=ref()
    let allCount=ref(0);
    const { run, data, refresh } = getCount();
    const getCountData = async () => {
      // let data = [
      //   { code: "spz", name: "审批中", count: 1 },
      //   { code: "yzf", name: "已作废", count: 1 },
      //   { code: "dtj", name: "待提交", count: 7 },
      //   { code: "ycx", name: "已撤销", flowCountMap: 1 },
      //   { code: "sptg", name: "审批通过", count: 17 },
      // ];
      flowCountMap.clear();
     let res= await run(props?.bizCode);
      //ts-gi
      let list = data.value?.countResp || [];
      list.map((d) => {
        flowCountMap.set(d.code, d);
      });
    };
    const handleArr = async () => {
      await getCountData();
      allCount.value=0;
      arr.value.map((item) => {
        item["count"] = flowCountMap.get(item.code)?.count || 0;
        if(item["code"]!='hsz'){
          allCount.value+=(item["count"]??0)
        }
      });
      if(!VoidBtnModuleArr.includes(props?.bizCode)){
        arr.value=arr.value.filter(a=>a.code!='yzf')
      }
      if(!changeBtnModuleArr.includes(props?.bizCode)){
        arr.value=arr.value.filter(a=>a.code!='bgz')
      }
      
      arr.value[0]["count"]=allCount.value;

    };
    onMountedOrActivated(async () => {
      arr.value=_.cloneDeep(flowStatusArr)
      await handleArr();
    });
    return {
      arr,
      changeTab,
      getCountData,
      allCount,
      refresh,
      handleArr
    };
  },
});
